import { render } from "./PatientFormData.vue?vue&type=template&id=925a7a62&scoped=true"
import script from "./PatientFormData.vue?vue&type=script&lang=js"
export * from "./PatientFormData.vue?vue&type=script&lang=js"

import "./PatientFormData.vue?vue&type=style&index=0&id=925a7a62&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-925a7a62"]])

export default __exports__